import { defineComponent } from "vue";
import CameraIcon from "@/assets/shared/icons/camera.svg";

export default defineComponent({
  data() {
    return {
      hasError: false,
      imagePath: null,
      cameraIconPath: CameraIcon
    };
  },
  methods: {
    pictureChanged(event: any) {
      const files = event.target.files;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imagePath = fileReader.result as any;
        this.hasError = false;
        this.$emit("imageChanged", this.imagePath);
      });
      fileReader.readAsDataURL(files[0]);
    },
    takePictureAgain() {
      this.imagePath = null;
      this.$emit("imageChanged", "");
    },
  },
});
